<template>
  <div>
    <el-row class="container" style="margin-top:15px;" :gutter="20">
      <!-- Columna Filtros -->
      <el-col class="container_col_1" :span="6">
       <el-row style="margin-bottom:15px;">
          <el-col :span="16">
            <div class="title">{{ $t('NAVBAR_presupuestos') }}</div>
          </el-col>
          <el-col :span="8" class="btn-nuevo">
            <router-link class="btn-nuevo" :to="{ name: 'Alta Presupuesto'}">
              <el-button type="primary" icon="Plus" size="small" round>{{ $t('GENERAL_nuevo') }}</el-button>
            </router-link>
          </el-col>
        </el-row>

        <!-- Busqueda simple -->
        <el-row>
          <el-collapse v-model="activeNames" style="margin-bottom: 5px;">
            <el-collapse-item class="busqueda" :title="$t('GENERAL_Busqueda_Simple')" name="1">
              <div class="filters" >

                <div class="filters_item">
                  <div class="label">{{$t('PRESUPUESTO_instancia')}}</div>
                    <el-select
                      class="seleccionador"
                      v-model="filtros.instancia"
                      size="small"
                      @change="getPresupuestosDelayed"
                      :placeholder="$t('PRESUPUESTO_instancia_ingresado')"
                    >
                      <el-option :value='""' :label="$t('GENERAL_OPCION_TODOS')"></el-option>
                      <el-option :value="'1'" :label="$t('PRESUPUESTO_instancia_ingresado')"></el-option>
                      <el-option :value="'2'" :label="$t('PRESUPUESTO_instancia_historico')"></el-option>
                  </el-select>
                </div>

                <div class="filters_item">
                  <div class="label">{{ $t('PRESUPUESTO_numero') }}</div>
                  <el-input
                    :placeholder="$t('PRESUPUESTO_numero_placeholder')"
                    size="small"
                    v-model="filtros.numero"
                    @input="getPresupuestosDelayed"
                  />
                </div>

                <div class="filters_item">
                  <div class="label">{{ $t('PRESUPUESTO_razon_social') }}</div>
                  <el-input
                    :placeholder="$t('PRESUPUESTO_razon_social_placeholder')"
                    size="small"
                    v-model="filtros.razonSocial"
                    @input="getPresupuestosDelayed"
                  />
                </div>

               <div class="filters_item">
                  <el-row style="text-align:left;">
                    <el-col :span="2">
                      <el-checkbox
                        v-model="filtros.checkPeriodo"
                        size="medium"
                        @change="changeCheck('P')">
                      </el-checkbox>
                    </el-col>

                    <el-col :span="20" style="text-align:left !important;">
                      <el-dropdown trigger="click" @command="changePeriodo">
                        <span
                          :class="{'el-dropdown-link': filtros.checkPeriodo, 'el-dropdown-link-active': !filtros.checkPeriodo}"
                        >
                          {{this.$t(filtros.periodo)}}
                          <el-icon><ArrowDown /></el-icon>
                        </span>
                        <template #dropdown>
                          <el-dropdown-menu>
                            <el-dropdown-item command="PRESUPUESTO_periodo_meses_1" :disabled="filtros.checkRango">{{$t('PRESUPUESTO_periodo_meses_1')}}</el-dropdown-item>
                            <el-dropdown-item command="PRESUPUESTO_periodo_meses_2" :disabled="filtros.checkRango">{{$t('PRESUPUESTO_periodo_meses_2')}}</el-dropdown-item>
                            <el-dropdown-item command="PRESUPUESTO_periodo_meses_3" :disabled="filtros.checkRango">{{$t('PRESUPUESTO_periodo_meses_3')}}</el-dropdown-item>
                            <el-dropdown-item command="PRESUPUESTO_periodo_ultimos_2a�os" :disabled="filtros.checkRango">{{$t('PRESUPUESTO_periodo_ultimos_2a�os')}}</el-dropdown-item>
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                    </el-col>
                  </el-row>
                </div>

                <div class="filters_item">
                  <el-row style="text-align:left; vertical-align:top;">
                    <el-col :span="2">
                      <el-checkbox
                        v-model="filtros.checkRango"
                        size="medium"
                        @change="changeCheck('R')">
                      </el-checkbox>
                    </el-col>
                    <el-col :span="20">
                      <div class="label" style="padding-top:3px !important;">{{$t('GENERAL_desde')}}</div>
                      <el-date-picker
                        style="width:90%"
                        v-model="filtros.from"
                        type="date"
                        size="small"
                        format="DD/MM/YYYY"
                        suffix-icon="Calendar"
                        placeholder="dd/mm/aaaa"
                        @input="getPresupuestosDelayed"
                        @change="getPresupuestosDelayed"
                        :picker-options="pickerOptionsFrom"
                        :disabled="filtros.checkPeriodo"
                      />

                      <div class="label">{{$t('GENERAL_hasta')}}</div>
                      <el-date-picker
                        v-model="filtros.to"
                        style="width:90%"
                        type="date"
                        size="small"
                        format="DD/MM/YYYY"
                        suffix-icon="Calendar"
                        placeholder="dd/mm/aaaa"
                        @input="getPresupuestosDelayed"
                        @change="getPresupuestosDelayed"
                        :picker-options="pickerOptionsTo"
                        :disabled="filtros.checkPeriodo"
                      />
                    </el-col>
                  </el-row>
                </div>


              <div class="clearFilters" @click="cleanFilters">{{$t('GENERAL_clean_filters')}}</div>
              </div>
            </el-collapse-item>

        <!-- Busqueda Avanzada -->

            <!-- <el-collapse-item class="busqueda" :title="$t('GENERAL_Busqueda_Avanzada')" name="0">
              <div class="filters">
                <div class="filters_item">
                  <div class="label">{{ $t('PEDIDO_marca') }}</div>
                  <el-input
                    :placeholder="$t('PEDIDO_marca_placeholder')"
                    size="small"
                    v-model="filtros.marca"
                    @input="getPedidosDelayed"
                  />
                </div>
                <div class="filters_item">
                  <div class="label">{{ $t('PEDIDO_modelo') }}</div>
                  <el-input
                    :placeholder="$t('PEDIDO_modelo_placeholder')"
                    size="small"
                    v-model="filtros.modelo"
                    @input="getPedidosDelayed"
                  />
                </div>
                <div class="filters_item">
                  <div class="label">{{ $t('PEDIDO_motor') }}</div>
                  <el-input
                    :placeholder="$t('PEDIDO_motor_placeholder')"
                    size="small"
                    v-model="filtros.motor"
                    @input="getPedidosDelayed"
                  />
                </div>
                <div class="filters_item">
                  <div class="label">{{ $t('PEDIDO_voltaje') }}</div>
                  <el-input
                    :placeholder="$t('PEDIDO_voltaje_placeholder')"
                    size="small"
                    v-model="filtros.voltaje"
                    @input="getPedidosDelayed"
                  />
                </div>

              <div class="clearFilters" @click="cleanFilters">{{$t('GENERAL_clean_filters')}}</div>
              </div>
            </el-collapse-item> -->
          </el-collapse>
        </el-row>
      </el-col>

      <!-- Resultados de b�squeda -->
      <el-col class="container_col_2" :span="17">
        <!-- Header resultados de b�squeda -->
        <el-row style="margin-bottom:15px;">
          <el-col :xs="8" :sm="12"  :md="10" :lg="16" :xl="16">
             <div class="sub-title">{{$t('GENERAL_resultado')}}</div>
          </el-col>
          <el-col :xs="16" :sm="12"  :md="14" :lg="8" :xl="8" class="pagination_container">
            <el-pagination
              background
              small
              layout="prev, pager, next"
              :current-page="paginador.page"
              :page-count="paginador.nro_pages"
              :page-size="paginador.pageSize"
              @current-change="handlePageChange"
              hide-on-single-page
              :pager-count="5"
            ></el-pagination>
          </el-col>
        </el-row>
        <!-- <el-row class="ordena">
          <el-col :span="24">
            <el-select class="ordenar" v-model="filtros.ordenar" clearable placeholder="Ordenar" size="small">
              <el-option value="Ascendente" label="Ascendente"></el-option>
              <el-option value="Descendente" label="Descendente"></el-option>
            </el-select>
          </el-col>
        </el-row> -->

        <!-- Presupuestos -->
        <el-row>
          <el-col :span="24">
            <div class="card_list">
            <div v-if="loading" v-loading.lock="loading" class="loader"></div>
            <div v-else-if="presupuestos !== undefined && presupuestos.length > 0" class="card_list_item" v-for="presupuesto in presupuestos" :key="presupuesto.Id">


              <PresupuestoCard
                :presupuesto="presupuesto"
                @editar="editarPresupuesto"
                @detalle="detallePresupuesto"
                @eliminar="eliminarPresupuesto"
              />

            </div>
            <div v-else class="loader">{{$t('GENERAL_no_data')}}</div>
          </div>
          </el-col>
        </el-row>

        <!-- Paginador abajo -->
        <el-row style="margin-top:10px;">
          <el-col :xs="8" :sm="12" :md="10" :lg="16" :xl="16"></el-col>
          <el-col :xs="16" :sm="12" :md="14" :lg="8" :xl="8" class="pagination_container">
            <el-pagination
              background
              small
              layout="prev, pager, next"
              :current-page="paginador.page"
              :page-count="paginador.nro_pages"
              :page-size="paginador.pageSize"
              @current-change="handlePageChange"
              hide-on-single-page
              :pager-count="5"
            ></el-pagination>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <AppDialog 
      :visible="eliminar_presupuesto"
      :title="$t('PRESUPUESTO_eliminar')"
      :message="eliminar_presupuesto_msg"
      :onClose="onCloseEliminarConfirmation"
    />
  </div>
</template>


<script>

  import PresupuestoCard from "@/components/Cards/presupuestoCard";
  import { mapState } from "vuex";
  import AppDialog from "../Dialog";
  import { showSuccess } from "../Mensaje";
  import { mostrarMensajeInternacionalizado } from "../MensajeInternacionalizado";

  let defaultPaginador = {
    page: 1,
    nro_pages: 1,
    pageSize: 20
  };

  let defaultFilters = {
      instancia: '1',
      numero: "",
      from: undefined,
      to: undefined,
      periodo: "PRESUPUESTO_periodo_meses_1",
      tipo_filtro: "PRESUPUESTO_periodo",
      ordenar: "",
      checkPeriodo: true,
      checkRango: false,
      razonSocial: "",
  };


  export default {
    name: "PresupuestosListado",
    components: { PresupuestoCard, AppDialog },
    data() {
      return {
        presupuesto: undefined,
        presupuestos: [],
        paginador: { ...defaultPaginador },
        filtros: { ...defaultFilters },
        activeNames: ["1"],
        loading: false,
        opened: false,
        pickerOptionsFrom: {
          disabledDate: this.disabledDateFrom
        },
        pickerOptionsTo: {
          disabledDate: this.disabledDateTo
        },
        eliminar_presupuesto_msg: "",
        eliminar_presupuesto: false,
        presupuesto_id: undefined,
      };
    },
    computed: {
      ...mapState({
        idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
      //modificar al tocar el state mas adelante
        ultimoFiltroAplicado: state => state.presupuestos.filtrosPresupuesto
      }),
    },

    methods: {

      changeCheck(check)
      {
        if(check =='P')
        {
          this.filtros.checkRango = this.filtros.checkPeriodo == true? false : true;
          this.filtros.tipo_filtro = "PRESUPUESTO_periodo";
        }
        else
        {
          this.filtros.checkPeriodo =this.filtros.checkRango == true? false:true;
          this.filtros.tipo_filtro = "PRESUPUESTO_rango";
        }

        this.getPresupuestos()
      },

      disabledDateFrom(time)
      {
        if (this.filtros.to !== "")
          return time.getTime() > this.filtros.to;

        else
          return false;
      },

      disabledDateTo(time)
      {
        if (this.filtros.from !== "")
          return time.getTime() < this.filtros.from;

        else
          return false;
      },

      handlePageChange(page)
      {
        this.paginador.page = page;
        this.getPresupuestos();
      },

      getPresupuestos()
      {

        // armo el payload
        let payload = { }
        payload.idUsuario = this.idUsuario
        payload.instancia = this.filtros.instancia
        payload.numero = this.filtros.numero
        payload.razonSocial = this.filtros.razonSocial
        if (this.filtros.tipo_filtro !== "PRESUPUESTO_periodo")
        {
          payload.desde = this.filtros.from;
          payload.hasta = this.filtros.to;

          if(!payload.desde && !payload.hasta)
            return
        }
        else
        {
          payload.mesesADesfazar = this.mapPeriodoToMeses();
        }

        payload.page = this.paginador.page
        payload.pageSize = this.paginador.pageSize


        // indico que se est�n buscando los presupuestos
        this.loading = true;

        // guardo los filtros aplicados
        this.$store.dispatch('presupuestos/setFiltrosPresupuesto', { ...this.filtros })
        // busco los presupuesto
        this.$store.dispatch('presupuestos/getPresupuestos', payload)
        .then(data =>
        {
          if(data.CodigoResultado == 0)
          {
            var paginado = JSON.parse(data.Datos)
            this.presupuestos = paginado.Result;
            this.paginador.nro_pages = paginado.TotalPages;
          }
        })
        .finally(() => (this.loading = false))
      },



      getPresupuestosDelayed()
      {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }

        this.timer = setTimeout(() => {
          this.paginador = { ...defaultPaginador };
          this.getPresupuestos();
        }, 1000);
      },

      changePeriodo(periodo)
      {

        this.filtros.periodo = periodo;
        this.getPresupuestos();
      },

      cleanFilters()
      {
        // limpio los filtros
        this.filtros = { ...defaultFilters };
        this.paginador = { ...defaultPaginador };

        // limpio los resultados de pedidos
        this.presupuestos = [];

        this.getPresupuestos();
      },

      toggleOpen()
      {
        this.opened = !this.opened
      },

      mapPeriodoToMeses()
      {
        switch (this.filtros.periodo)
        {
          case "PRESUPUESTO_periodo_meses_1":
            return -1;
          case "PRESUPUESTO_periodo_meses_2":
            return -2;
          case "PRESUPUESTO_periodo_meses_3":
            return -3;
          case "PRESUPUESTO_periodo_ultimos_2a�os":
            return -24;
          default:
            return 1;
        }
      },

      editarPresupuesto(id)
      {
        this.$router.push({ name: 'Edicion Presupuesto', params: {id}});
      },

      detallePresupuesto(id)
      {
        this.$router.push({ name: 'Detalle Presupuesto', params:{id}});
      },
      eliminarPresupuesto(id){
        this.eliminar_presupuesto_msg = this.$t('PRESUPUESTO_eliminar_mensaje');
        this.eliminar_presupuesto = true;
        this.presupuesto_id = id;
      },
      onCloseEliminarConfirmation(confirm){

        if(confirm){
          this.deletePresupuesto(this.presupuesto_id);
        }

        this.eliminar_presupuesto_msg = "";
        this.eliminar_presupuesto = false;
        this.presupuesto_id = undefined;
      },
      deletePresupuesto(id){
        let payload = { }
        payload.idUsuario = this.idUsuario
        payload.id = id

        this.$store.dispatch("pedidos/eliminarPedido", payload)
          .then(result => {
            if (result.CodigoResultado != 0)  mostrarMensajeInternacionalizado(
                result.CodigoResultado,
                result.DescripcionResultado
              );
            else showSuccess(this.$t("GENERAL_success"));
          })
          .finally(() => (this.getPresupuestos()));

      },
    },

    mounted()
    {
      //Scroll para Android
       document.body.scrollTop = 0;
       //Scroll para IOS
       document.documentElement.scrollTop = 0;
      // verifico si se pas� un n�mero de presupuesto como par�metro
      if(this.$route.params.numeroPresupuesto !== undefined)
      {
        this.filtros.numero = this.$route.params.numeroPresupuesto;
        this.filtros.instancia = '2';
      }

      // verifico si se deben mantener los �ltimos filtros aplicados
      if (this.$route.params.keepFilter === true)
        this.filtros = { ...this.ultimoFiltroAplicado };

      // busco los pedidos
      this.getPresupuestos();
    }
  }

</script>

<style scoped>

.greyLabel {
  color: #6B6B6B;
  font-weight: normal;
}


.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  font-weight: bold;
}

.label {
  text-align: left;
  margin-bottom: 4px;
  font-size: 14px;
}

.seleccionador {
    width: 100%;
    padding: 0;
}

.btn-nuevo {
  padding-right:0%;
  text-align:right;
}
.el-card {
  height: 100%;
}
.cardBody {
  padding-left: 25px;
}

.container {
  display: flex;
  min-height: 500px !important;
  width:  100% !important;
}

.pagination_container {
  text-align: right;
  padding-right:0px;
}

.container_col_1 .el-collapse,
.container_col_1 .el-collapse.el-collapse-icon-position-right {
  width: 100%;
}
@media (max-width: 1100px){
  .container_col_1 {
    flex: 1;
    width:100% !important;
  }
}
@media (max-width: 900px) {
  .busqueda {
  font-size: 10px;
  }
  .container_col_2 {
    flex: 1;
    width:100% !important;
    margin-top:20px;
  }
}

@media (max-width: 600px) {
  .container {
    flex-direction: column;
  }
  .container_col_1 {
    flex: 0 0 100% !important;
    width:100% !important;
    max-width:100% !important;
  }
  .container_col_2 {
    flex: 0 0 100% !important;
    width:100% !important;
    max-width:100% !important;
    margin-top:20px;
  }
  .busqueda {
  font-size: 14px;
  }
}

.card {
  width: 100%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.10);
  justify-self: center;
}

.card_list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  grid-gap: 1rem;
}
.card_list_item {
  position: relative;
}

.title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: var(--main-color);
}
.sub-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #999;
}
.filters {
  display: flex;
  flex-direction: column;
}
.filters_item {
  flex: 1;
  margin-bottom: 10px;
}


.clearFilters {
  color: #5aabc6;
  font-size: 14px;
  text-align: left;
  margin-top: 10px;
  cursor: pointer;
}

.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.soonToExpire {
  font-size: 14px;
  color: #2e2e2e;
  font-weight: bold;
  text-align: left;
  margin-top: 40px;
}
.el-radio-group {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-top: 14px;
}
.el-radio {
  line-height: 2;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.loader {
  margin-top: 25%;
  color: #999;
}
.ordena{
  text-align: right;
  margin-bottom: 20px;
}
</style>

<style>
.ordenar .el-input__inner{
  border: none;
  width: 70%;
}
.el-icon-arrow-up:before{
  color:#409EFF;
  font-weight: bold;
}
.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  font-weight: bold;
}
.greyLabel {
  font-size: 14px;
  color: #6b6b6b;
  text-align: left;
  font-weight: normal;
}

</style>

